import React, { useState } from 'react'
import {
  Box,
  CircularProgress,
  FormLabel,
  Grid,
  Modal,
  styled,
  Typography,
  Button,
  DialogActions,
  Fade,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  useMediaQuery,
} from '@mui/material'
import { BorderButtonPurple, CustomButton } from '../buttons'
import lightTheme from '../../styles/theme/lightTheme'
import '../../styles/components/_box.scss'
import '../../styles/components/_grids.scss'
import '../../styles/components/_inputs.scss'
import '../../styles/components/_errors.scss'
import { SelectInput } from '../inputs'
import { useTranslation } from 'react-i18next'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import GradientButton from '../buttons/GradientButton'
import OutlineButton from '../buttons/OutlineButton'

const ModalContainer = styled(Box)(({ theme }) => ({
  width: 'calc(100% - 32px)',
  maxWidth: 800,
  minHeight: 400,
  maxHeight: '90vh',
  backgroundColor: '#FFFFFF',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '16px',
  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
  padding: '32px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',

  '&:focus-visible': {
    outline: 'none',
  },

  [theme.breakpoints.up('sm')]: {
    width: 800,
    padding: '20px 40px',
  },
}))

const BoxContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}))

const FormSection = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  padding: '20px',
  borderRadius: '20px',
  border: '1px solid rgba(229, 231, 235, 0.95)',
  backgroundColor: '#f8fafc',
}))

const OptionBlock = styled(Box)(({ ownerState }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  borderRadius: '16px',
  padding: '16px',
  width: '100%',
  flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' },
  textAlign: 'left',
  cursor: 'pointer',
  border: ownerState.selected
    ? '1px solid #4338ca'
    : '1px solid rgba(203, 213, 225, 1)',
  backgroundColor: ownerState.selected ? 'rgba(79, 70, 229, 0.12)' : '#ffffff',
  color: ownerState.selected ? '#4338ca' : '#334155',
  transition: 'all 0.2s ease',
  '&:hover': {
    borderColor: '#4f46e5',
    backgroundColor: ownerState.selected
      ? 'rgba(79, 70, 229, 0.18)'
      : 'rgba(241, 245, 249, 1)',
  },
}))

const SelectBlock = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  padding: '12px 14px',
  borderRadius: '18px',
  backgroundColor: '#ffffff',
  border: '1px solid rgba(203, 213, 225, 1)',
}))

const ChoiceOfferModalEntreprise = ({
  open,
  onClose,
  openDelete,
  items,
  handleClick,
  handleClickOffreEntreprise,
  handleClickOffreCandidat,
  errors,
  register,
  handleChange,
  value,
  loading,
  role,
  type,
}) => {
  const { t } = useTranslation()
  const durre = [
    { id: 10, text: '10 jours', value: '10', type: 'days' },
    { id: 30, text: '30 jours', value: '30', type: 'days' },
    { id: 45, text: '45 jours', value: '45', type: 'days' },
    { id: 3, text: '3 Mois', value: '3', type: 'months' },
    { id: 6, text: '6 Mois', value: '6', type: 'months' },
    { id: 12, text: '12 Mois', value: '12', type: 'months' },
  ]
  const [durreSelect, setDurreSelect] = useState('10 days')
  const handleDureeSelect = (event) => {
    const inputValue = event.target.value
    setDurreSelect(inputValue)
  }

  const status = [
    { id: 1, text: 'Payé', value: 'payer' },
    { id: 2, text: 'À payer', value: 'non-payer' },
  ]
  const [statusSelect, setStatusSelect] = useState('payer')
  const handleStatusSelect = (event) => {
    const inputValue = event.target.value
    setStatusSelect(inputValue)
  }

  console.log(items)

  const fullScreen = useMediaQuery(lightTheme.breakpoints.down('sm'))
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={fullScreen}
      scroll={'paper'}
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : '16px',
          p: fullScreen ? 0 : '8px',
          m: fullScreen ? 0 : undefined,
          maxHeight: fullScreen ? '100%' : '90vh',
          ...(fullScreen && {
            display: 'flex',
            flexDirection: 'column',
          }),
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
          px: { xs: 2, sm: 3 },
          py: { xs: 1.5, sm: 2 },
          pb: 2,
          flexShrink: 0,
          borderBottom: '1px solid rgba(229, 231, 235, 0.8)',
          backgroundColor: 'rgba(249, 250, 251, 0.5)',
        }}
      >
        <Typography
          variant={fullScreen ? 'subtitle1' : 'h6'}
          sx={{ fontWeight: 600, color: '#1f2937', pr: 1, lineHeight: 1.3 }}
        >
          {t('box.title.offer')}
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: '#6b7280',
            '&:hover': {
              backgroundColor: 'rgba(107, 114, 128, 0.1)',
              color: '#374151',
            },
          }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 1, pt: '32px !important' }}>
        <Box
          component="form"
          sx={{
            display: 'grid',
            gap: 2,
            width: '100%',
          }}
        >
          <FormSection>
            <FormLabel className={'labelForm'}>
              {t('box.selectOffer')}
            </FormLabel>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 2,
              }}
            >
              {items?.map((item) => {
                const selected =
                  (value && value.id && item.id === value.id) ||
                  value === item ||
                  value === item.id
                return (
                  <OptionBlock
                    key={item.id}
                    ownerState={{ selected }}
                    onClick={() => handleChange({ target: { value: item } })}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 0.5,
                        width: '100%',
                      }}
                    >
                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                        {item.name}
                      </Typography>
                      {item.type && (
                        <Typography
                          variant="caption"
                          sx={{ fontSize: '0.75rem', opacity: 0.8 }}
                        >
                          {item.type}
                        </Typography>
                      )}
                      {item.features &&
                        Object.keys(item.features).length > 0 && (
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 0.5,
                              mt: 0.5,
                            }}
                          >
                            {Object.values(item.features).map(
                              (feature, idx) => (
                                <Typography
                                  key={idx}
                                  variant="caption"
                                  sx={{
                                    fontSize: '0.7rem',
                                    opacity: 0.7,
                                    pl: 1,
                                  }}
                                >
                                  • {feature.name}
                                </Typography>
                              )
                            )}
                          </Box>
                        )}
                      {item.basePrice ? (
                        <Typography
                          variant="caption"
                          sx={{ fontWeight: 500, mt: 0.5, color: '#4338ca' }}
                        >
                          {
                            JSON.parse(sessionStorage.getItem('currency'))
                              .devise
                          }{' '}
                          {(
                            item.basePrice *
                            JSON.parse(sessionStorage.getItem('currency'))
                              .currentRate
                          ).toFixed(2)}
                        </Typography>
                      ) : (
                        <Typography
                          variant="caption"
                          sx={{ fontWeight: 500, mt: 0.5, color: '#4338ca' }}
                        >
                          Gratuit
                        </Typography>
                      )}
                    </Box>
                  </OptionBlock>
                )
              })}
            </Box>
            {/*{errors.func && (
                  <Typography className={"error-message"}>
                    {errors.func.message}
                  </Typography>
                )}*/}
          </FormSection>

          {role === 'ROLE_ADMIN' && (
            <FormSection>
              {type === 'entreprise' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <FormLabel className={'labelForm'}>Durée</FormLabel>
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 2,
                    }}
                  >
                    {durre.map((option) => (
                      <OptionBlock
                        key={option.id}
                        ownerState={{ selected: durreSelect.value === option.value }}
                        onClick={() =>
                          handleDureeSelect({ target: { value: option } })
                        }
                      >
                        {option.text}
                      </OptionBlock>
                    ))}
                  </Box>
                </Box>
              )}

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <FormLabel className={'labelForm'}>Statut</FormLabel>
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  {status.map((option) => (
                    <OptionBlock
                      key={option.id}
                      ownerState={{ selected: statusSelect === option.value }}
                      onClick={() =>
                        handleStatusSelect({ target: { value: option.value } })
                      }
                    >
                      {option.text}
                    </OptionBlock>
                  ))}
                </Box>
              </Box>
            </FormSection>
          )}
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          px: { xs: 2, sm: 4 },
          py: { xs: 2, sm: 3 },
          gap: 2,
          justifyContent: 'center',
          backgroundColor: 'rgba(249, 250, 251, 0.8)',
          borderTop: '1px solid rgba(229, 231, 235, 0.8)',
          flexDirection: { xs: 'column', sm: 'row' },
          flexShrink: 0,
          flexWrap: 'wrap',
          '& > *': {
            width: { xs: '100%', sm: 'auto' },
            m: 0,
          },
        }}
      >
        <OutlineButton onClick={onClose} fullWidth={fullScreen}>
          {t('button.cancel')}
        </OutlineButton>

        <GradientButton
          fullWidth={fullScreen}
          onClick={() =>
            role === 'ROLE_ADMIN'
              ? type === 'entreprise'
                ? handleClickOffreEntreprise(durreSelect, statusSelect)
                : handleClickOffreCandidat(durreSelect, statusSelect)
              : handleClick()
          }
        >
          {loading ? (
            <>
              <CircularProgress size={16} sx={{ mr: 1, color: 'white' }} />
              {t('profile.saving')}
            </>
          ) : (
            t('button.save')
          )}
        </GradientButton>
      </DialogActions>
    </Dialog>
  )
}

export default ChoiceOfferModalEntreprise
